import React, { useState } from 'react';
import {
  ButtonGroup,
  Paper
} from 'e100-react-components';
import { MAP_TYPES, MapType } from 'common/utils/Map/constants';

import MapButton from './MapButton';
import SatelliteButton from './SatelliteButton';

import { useShowStreetView } from 'entities/map';

const MapTypeControl = () => {
  const [mapType, setMapType] = useState<MapType>(() => MAP_TYPES.ROADMAP);
  const showStreetView = useShowStreetView();

  if (showStreetView) {
    return null;
  }

  return (
    <Paper
      elevation={2}
    >
      <ButtonGroup variant="contained" disableElevation>
        <MapButton
          mapType={mapType}
          setMapType={setMapType}
        />
        <SatelliteButton
          mapType={mapType}
          setMapType={setMapType}
        />
      </ButtonGroup>
    </Paper>
  );
};

export type setMapType = React.Dispatch<React.SetStateAction<MapType>>;

export default MapTypeControl;
